export class RechargeHistory {
    public amount!: number;
    public createdBy!: string;
    public createDate!: string;
    public id!: number;
    public method!: number;
    public rechargeId!: number;
    public status!: number;
    public statusDetail!: any;
    public tradeContent!: string;
    public userRecharge!: string;
    public userName!: string;
}